module.exports = __webpack_public_path__ + "static/img/point_1_1.7e29317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq/point_1_1.jpg
// module id = eCoz
// module chunks = 1